import { useTranslation } from 'react-i18next';
import { Button } from 'antd';
import { EditIcon, TrashIcon } from '@/assets/icons';
import { cn } from '@/libs/utils';

export default function OwnersTableActions({
  owners,
  row,
  handleEdit,
  handleRemove,
}) {
  const { t } = useTranslation(['menus']);

  return (
    <div className="flex gap-2">
      <Button
        type="button"
        title={t('edit', { ns: 'menus' })}
        className={cn(
          'btn-default h-8 w-8 items-center justify-center rounded-md !p-0'
        )}
        onClick={() => {
          handleEdit(owners.indexOf(row));
        }}
        icon={<EditIcon className="w-[14px]" />}
      >
        <span className="sr-only">{t('edit', { ns: 'menus' })}</span>
      </Button>

      <Button
        type="danger"
        title={t('remove', { ns: 'menus' })}
        className={cn(
          'btn-danger h-8 w-8 items-center justify-center rounded-md !p-0'
        )}
        onClick={() => {
          handleRemove(owners.indexOf(row));
        }}
        icon={<TrashIcon className="w-[14px]" />}
      >
        <span className="sr-only">{t('remove', { ns: 'menus' })}</span>
      </Button>
    </div>
  );
}
